'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getActiveFormField = exports.getFormFieldValue = exports.getFormSelector = exports.getFormValues = exports.getForm = undefined;

var _reduxForm = require('redux-form');

var _getFormValues = require('redux-form/es/getFormValues');

var _getFormValues2 = _interopRequireDefault(_getFormValues);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var getForm = exports.getForm = function getForm(state) {
  return state.form;
};

var getFormValues = exports.getFormValues = function getFormValues(state) {
  return (0, _getFormValues2.default)(state);
};

var getFormSelector = exports.getFormSelector = function getFormSelector(formName) {
  return formName && (0, _reduxForm.formValueSelector)(formName);
};

var getFormFieldValue = exports.getFormFieldValue = function getFormFieldValue(state, props) {
  var shouldGet = props && props.formName && props.fieldName;

  if (shouldGet) {
    return getFormSelector(props.formName)(state, props.fieldName);
  }
};

var getActiveFormField = exports.getActiveFormField = function getActiveFormField(state, props) {
  var form = state.form[props.formName] || {};
  return form.active || '';
};